import { render, staticRenderFns } from "./StoreAdmins.vue?vue&type=template&id=af4bd216&scoped=true&"
import script from "./StoreAdmins.vue?vue&type=script&lang=js&"
export * from "./StoreAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4bd216",
  null
  
)

export default component.exports